import { Grid, TextField } from '@mui/material'
import React, { useContext } from 'react'
import DateField from '../../../components/DateField/DateField'
import { cpfMask, currencyMask } from '../../../utils/masks'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { PropostaContext } from './index'

const HeaderTabs = () => {
  const { dadosEdicao } = useContext(PropostaContext)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <TextField
          name="cdCpf"
          InputLabelProps={{ shrink: dadosEdicao.cdCpf }}
          label="CPF"
          fullWidth
          margin="dense"
          variant="outlined"
          size="small"
          disabled
          InputProps={cpfMask}
          value={dadosEdicao.cdCpf}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          name="dsNome"
          label="Nome"
          InputLabelProps={{ shrink: dadosEdicao.dsNome }}
          fullWidth
          margin="dense"
          variant="outlined"
          disabled
          size="small"
          value={dadosEdicao.dsNome}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <DateField
          name="dtNascimento"
          label="Dt. Nascimento"
          fullWidth
          value={dadosEdicao?.dtNascimento}
          disabled
        />
      </Grid>
      <Grid justifyContent="flex-end" container spacing={2} item xs={12}>
        <Grid item xs={12} md={2}>
          <CurrencyField
            name="vlCaucao"
            label="Caução"
            fullWidth
            variant="outlined"
            margin="dense"
            disabled
            size="small"
            value={dadosEdicao.vlCaucao}
            customInput={TextField}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            margin="dense"
            variant="outlined"
            name="vlSubTotal"
            size="small"
            disabled
            label="Subtotal"
            value={'R$: ' + currencyMask(dadosEdicao.vlSubTotal)}
          />
        </Grid>

        {Number(dadosEdicao.vlDescontoCheckin || 0) > 0 && (
          <Grid item xs={12} md={2}>
            <CurrencyField
              name="vlDescontoCheckin"
              label="Desconto Check-in"
              fullWidth
              margin="dense"
              variant="outlined"
              size="small"
              value={dadosEdicao.vlDescontoCheckin}
              disabled
            />
          </Grid>
        )}

        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            variant="outlined"
            margin="dense"
            name="vlTotal"
            disabled
            label="Saldo Devedor"
            size="small"
            value={`R$: ${currencyMask(dadosEdicao.vlTotal)}`}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HeaderTabs
